<div class="tpp-ejourney-container document-capture-container">
  @if (document.isSubmitted === false) {
    <form [formGroup]="tppForm">
      @if (instructions) {
        <div id="instruction-container">
          <!-- <strong>Just make sure</strong><br /> -->
          <span>Your finance provider has been in touch with the person paying for your insurance. Please make sure they
          complete the finance application.</span><br />
          <span>Please note that you are both required to complete separate steps:</span><br />
          @for (instruction of instructions; track instruction) {
            <span>- {{ instruction }} <br /></span>
          }
          <span>Your agreement will only be authorised once both parties have completed their requirements.</span><br />
        </div>
      }
    </form>
  }
  @if (document.isSubmitted === true) {
    <app-upload-confirmation></app-upload-confirmation>
  }
</div>
